import { shipments, fulfillments, batches, returns } from '../../../filters/options/fulfillment-type/options';

import shipmentsView from './shipments';
import fulfillmentsView from './fulfillments';
import batchesView from './batches';
import returnsView from './returns';

export default {
  [shipments.id]: shipmentsView,
  [fulfillments.id]: fulfillmentsView,
  [batches.id]: batchesView,
  [returns.id]: returnsView,
};
